module.exports = __webpack_public_path__ + "img/PPMP12.4818b45e.png";